import React from "react";

const languages = window["localization"];
var langs = Object.keys(languages);

const SelectLanguage = ({ heading }) => {
  let setLanguageOnChange = (language) => {
    let url = window.location.href;
    let index = url.indexOf("lang=");
    let selectedLang = index !== -1 ? url.substring(index, index + 7) : "";
    if (url.includes("?lang=")) {
      url = url.replace(`?${selectedLang}`, `?lang=${language}`);
    } else if (url.includes("&lang=")) {
      url = url.replace(`&${selectedLang}`, `&lang=${language}`);
    } else {
      if (url.split("?")[1] !== undefined) {
        url += `&lang=${language}`;
      } else {
        url += `?lang=${language}`;
      }
    }
    window.location.href = url;
    localStorage.setItem("lang", language);
  };

  return (
    <div>
      <h3
        style={{
          float: "right",
          fontWeight: "bold",
        }}
      >
        {heading}
      </h3>
      <br />
      <br />
      <select
        className="selectpicker"
        style={{
          float: "right",
        }}
        value={localStorage.getItem("lang")}
        onChange={(e) => {
          setLanguageOnChange(e.target.value.split("_")[0]);
        }}
      >
        {langs.map((data, index) => (
          <option key={index} value={data.split("_")[0]}>
            {data.split("_")[1]}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectLanguage;
